module.exports = __webpack_public_path__ + "img/VITA HUSTLE 30 DAY HUSTLE.8610a2b0.png";